

export default {
  getInventaireById: state => id => {
    return state.inventaires ? state.inventaires.find((i) => i._id === id) : null
  }
}
